import ResetPassword from "../../components/ResetPassword";

export const ResetPasswordPage = () => {
	return (
		<div className="flex w-full justify-center items-center p-2 bg-gradient-to-br from-cyan-100 to-fuchsia-200">
			<ResetPassword />
		</div>
	);
};
